export default __webpack_public_path__ + "static/media/2.21fa765c.jpg";